export type MySongsPageSortColumnType = "song.title" | "artist.name" | "song.popularity" | "song.dateAdded";
export type MySongsPageSortDirectionType = "asc" | "desc";

export interface IMySongsPageSortConfigDisplay {
  title: string;
  asc?: string;
  desc?: string;
}

export interface IMySongsPageSortConfigOption {
  column: MySongsPageSortColumnType;
  defaultDirection?: MySongsPageSortDirectionType;
  display: IMySongsPageSortConfigDisplay;
  hideSortOrderControls?: boolean;
}

export type MySongsPageSortConfigOptionsType = IMySongsPageSortConfigOption[];

export interface IMySongsPageDefaultSortConfig {
  column: MySongsPageSortColumnType;
  direction: MySongsPageSortDirectionType;
  ascendingLabel: string,
  descendingLabel: string,
}

export const mySongsPageDefaultSortConfig: IMySongsPageDefaultSortConfig = {
  column: "song.popularity",
  direction: "desc",
  ascendingLabel: 'A to Z',
  descendingLabel: 'Z to A',
}

export const mySongsPageSortOptionsConfig: MySongsPageSortConfigOptionsType = [
  {
    column: "song.dateAdded",
    defaultDirection: "desc",
    display: {
      title: `Date Added`,
      asc: 'Oldest to Newest',
      desc: 'Newest to Oldest',
    },
  },
  {
    column: "song.title",
    defaultDirection: "asc",
    display: {
      title: `Song Title`,
    },
  },
  {
    column: "song.popularity",
    defaultDirection: "desc", // desc = highest "popularity score" first
    display: {
      title: `Popularity`,
    },
    hideSortOrderControls: true,
  },
  {
    column: "artist.name",
    defaultDirection: "asc",
    display: {
      title: `Artist Name`
    },
  },
];

export const mySongsPageSorters = {
  get: (activeSortColumn: MySongsPageSortColumnType): IMySongsPageSortConfigOption | undefined =>
    mySongsPageSortOptionsConfig.find(({column})=> activeSortColumn === column),
  getMenuLabel: (activeSortColumn: MySongsPageSortColumnType): string =>
    mySongsPageSorters.get(activeSortColumn)?.display.title ?? `${activeSortColumn}`,
  getSortDirectionLabel: (
    activeSortColumn: MySongsPageSortColumnType,
    activeSortDirection: MySongsPageSortDirectionType,
  ): string => {
    const defaultLabel = activeSortDirection === "asc"
      ? mySongsPageDefaultSortConfig.ascendingLabel
      : mySongsPageDefaultSortConfig.descendingLabel;

    return mySongsPageSorters.get(activeSortColumn)?.display[activeSortDirection] ?? defaultLabel;
  }
}

export interface ISongsFilterSortConfig {
  default: IMySongsPageDefaultSortConfig;
  options: MySongsPageSortConfigOptionsType;
}

export const songsFilterSortConfig: ISongsFilterSortConfig = {
  default: mySongsPageDefaultSortConfig,
  options: mySongsPageSortOptionsConfig,
}
